const CMS_BASE = 'https://api.dev.auxo.dk/public';

/**
 * Fetch an entire collection as array
 */
export async function getCollection(collectionName) {
  try {
    const res = await fetch(`${CMS_BASE}/content/${collectionName}`, {
      headers: {
        Accept: 'application/json',
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    const data = await res.json();
    return Array.isArray(data) ? data : (data.items || []);
  } catch (err) {
    console.warn(`CMS fetch failed for ${collectionName}:`, err);
    return [];
  }
}

/**
 * Fetch paged or filtered items via v2 endpoint
 */
export async function getCollectionV2(collectionName, params = {}) {
  try {
    const query = new URLSearchParams();
    Object.entries(params).forEach(([k, v]) => {
      if (v !== undefined && v !== null && v !== '') {
        query.append(k, v);
      }
    });
    const url = `${CMS_BASE}/v2/content/${collectionName}${query.toString() ? '?' + query.toString() : ''}`;
    const res = await fetch(url, {
      headers: {
        Accept: 'application/json',
      },
    });
    if (!res.ok) {
      throw new Error(`HTTP ${res.status}`);
    }
    return await res.json();
  } catch (err) {
    console.warn(`CMS v2 fetch failed for ${collectionName}:`, err);
    return { items: [], total: 0, limit: 25, offset: 0 };
  }
}

/**
 * Fetch a single entry by its slug
 */
export async function getEntryBySlug(slug) {
  try {
    const res = await fetch(`${CMS_BASE}/by-slug/${encodeURIComponent(slug)}`);
    if (!res.ok) return null;
    return await res.json();
  } catch (err) {
    console.warn(`CMS fetch by slug failed for ${slug}:`, err);
    return null;
  }
}

/**
 * Helper to generate Cloudflare image URLs with optimal width and format=auto
 */
export function optimizeImage(url, width = 800) {
  if (!url || typeof url !== 'string') return url;
  if (!url.includes('assets.auxodev.dk') || url.includes('/cdn-cgi/image/')) {
    return url;
  }
  return url.replace(
    'https://assets.auxodev.dk/',
    `https://assets.auxodev.dk/cdn-cgi/image/width=${width},quality=85,format=auto/`
  );
}
